import { SEARCH_SAVED_TEMPLATES, SEARCH_SAVED_TEMPLATES_ERROR, SEARCH_SAVED_TEMPLATES_SUCCESS } from './constants';

export const searchSavedTemplates = (text, searchType) => ({
  type: SEARCH_SAVED_TEMPLATES,
  text,
  searchType,
});

export const searchSavedTemplatesError = (error) => ({
  type: SEARCH_SAVED_TEMPLATES_ERROR,
  error,
});

export const searchSavedTemplatesSuccess = (savedTemplates) => ({
  type: SEARCH_SAVED_TEMPLATES_SUCCESS,
  savedTemplates,
});
